export const CLEAR_QUESTIONS_META = `CLEAR_QUESTIONS_META`;

export const clearQuestionsMeta = () => ({
  type: CLEAR_QUESTIONS_META,
});
